export function shuffleArray(array: any) {
  const newArray = array;
  for (let i = newArray.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1)); // Gera um índice aleatório entre 0 e i (incluindo i)
    [newArray[i], newArray[j]] = [newArray[j], newArray[i]]; // Troca os elementos nas posições i e j
  }
  return newArray;
}